import React, {useState , useEffect } from 'react'
import { UseGlobelcourse } from './allcoursecontaxt/ALLCoursecontaxt'
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import ReCAPTCHA from "react-google-recaptcha";
import { Modal, Button } from 'react-bootstrap';

import { UseGlobellogin } from './Logincontaxt.jsx/Logincontex';
import { BASE_URL } from '../Config/Config';
import SubLoading from '../ALL CSS/Loading';
function Our_Instructors() {
 
    const {instructer_detail , Getsingleinstructer , single_instructer , openinstructer , handleClose} = UseGlobelcourse();
    const [formMessage, setFormMessage] = useState(''); // State to hold the success message
    
    const [errors, setErrors] = useState({});
    const [Enable, setEnable] = useState(true);
    const {setsuccessfully} = UseGlobellogin();
    
  const [isModalOpen, setIsModalOpen] = useState(false);


  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

 const [data, setData] = useState({
    name:"",
    email:"",
    mobile_number:"",
    message:"",
    page_name : "Our Instructors page"
  });

   const [bannerData , setBannerImage] = useState([]);
    const [bannerLoading , setBannerLoading] = useState(true);
  
    useEffect(() => {
      const fetchBannerImage = async () => {
        try {
          setBannerLoading(true);
          const response = await fetch(`${BASE_URL}/banner/?page=Our-Instructors`);
          const result = await response.json();
          setBannerImage(result.data[0]);
              } catch (error) {
                console.error('Error fetching banner:', error);
              } finally {
                setBannerLoading(false);
              }
            };
            
            fetchBannerImage();
          }, []);

  function onChange(value) {
    console.log("Captcha value:", value);
    setEnable(false);
  }
  const handleInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setData({
      ...data,
      [name]: value
    });
  };

  const validateForm = () => {
    const fieldErrors = {};
    if (data.name.length < 3) fieldErrors.name = 'Name must be at least 3 characters long.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) fieldErrors.email = 'Invalid email address.';
    if (!/^[0-9]{10}$/.test(data.mobile_number))
      fieldErrors.mobile_number = 'Mobile number must be exactly 10 digits.';
    if (data.message.trim() === '') fieldErrors.message = 'Message cannot be empty.';
    setErrors(fieldErrors);
    return Object.keys(fieldErrors).length === 0; // Return true if no errors
  };


  const submitForm = async (e) => {
    e.preventDefault();

    const formData = {
      name: data.name,
      email: data.email,
      mobile_number: data.mobile_number,
      message: data.message,
      page_name : data.page_name
    };

    if (!validateForm()) {
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/contactform/`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      const result = await response.json();
      
      if (response.ok) {
        setData({
          name: '',
          email: '',
          mobile_number:'',
          message: '',
        });
        setsuccessfully(result.message);
        setTimeout(() => setsuccessfully(""), 10000);
        setIsModalOpen(false);
      } 
      else {
        setFormMessage(result.message || 'Error submitting the form');
          setTimeout(() => setFormMessage(""), 5000);
      }
    } catch (error) {
      setFormMessage('Error submitting the form');
       setTimeout(() => setFormMessage(""), 5000);
    }
  };
  console.log(instructer_detail)
  return (
    <>
   {
      bannerLoading && bannerData && bannerData?.image ? (
        <SubLoading/>
      ):(
   <div className="breadcumb-wrapper"

style={{
       backgroundImage: `url(${BASE_URL}${bannerData?.image})`,
       backgroundSize: 'contain',
       backgroundPosition: 'center',
       height:"50px"
     }}    data-overlay="title" data-opacity={8} >
  <div className="breadcumb-shape" data-bg-src="assets/img/bg/breadcumb_shape_1_1.png">
  </div>
  <div className="shape-mockup breadcumb-shape2 jump d-lg-block d-none" data-right="30px" data-bottom="30px">
    <img src="assets/img/bg/breadcumb_shape_1_2.png" alt="shape" />
  </div>
  <div className="shape-mockup breadcumb-shape3 jump-reverse d-lg-block d-none" data-left="50px" data-bottom="80px">
    <img src="assets/img/bg/breadcumb_shape_1_3.png" alt="shape" />
  </div>
  <div className="container">
    <div className="breadcumb-content text-center">
      <h1 className="breadcumb-title">Our Instructors</h1>
      <ul className="breadcumb-menu">
        <li><a href="index.html">Home</a></li>
        <li>Instructors</li>
      </ul>
    </div>
  </div>
     </div>
      )}
      {/* Team Area   */}
   <div className="team-area overflow-hidden space">
  <div className="container">
    <div className="row align-items-center gy-4">

      {/* Single Item */}

     {
      instructer_detail.map((curinstrter , index)=>(
      <div className="col-sm-6 col-lg-4 col-xl-3" key={index} id="target-section">
        <div className="team-card style3">
          <div className="team-img-wrap">
            <div className="team-img" onClick={()=>Getsingleinstructer(curinstrter.slug)}>
              <img src={`${BASE_URL}${curinstrter.CourseInstructor_image}`} alt="Team" />
            </div>
          </div>
          <div className="team-hover-wrap">
            <div className="team-social">
              <a href="#" className="icon-btn">
                <i className="far fa-plus" />
              </a>
              <div className="th-social">
                <a target="_blank" href={curinstrter.CourseInstructor_youtube_url}><i className="fab fa-vimeo-v" /></a>
                <a target="_blank" href={curinstrter.CourseInstructor_linkedin_url}><i className="fab fa-linkedin-in" /></a>
                <a target="_blank" href={curinstrter.CourseInstructor_twitter_url}><i className="fab fa-twitter" /></a>
                <a target="_blank" href={curinstrter.CourseInstructor_instgrame_url}><i className="fa-brands fa-instagram" /></a>
              </div>
            </div>
            <div className="team-content">
              {/* <h3 className="team-title"><NavLink to={`/team-detail/${curinstrter.slug}`}>{curinstrter.CourseInstructor_name}</NavLink></h3> */}
              <h3 className="team-title" style={{cursor:"pointer"}} onClick={()=>Getsingleinstructer(curinstrter.slug)}>{curinstrter.CourseInstructor_name} </h3>
                 <span className="team-desig">{curinstrter.CourseInstructor_desig}</span>
            </div>


            {/* <div className="team-info">
              <span><i className="fal fa-file-check" />2 Courses</span>
              <span><i className="fa-light fa-users" />Students 60+</span>
            </div> */}
<p
  dangerouslySetInnerHTML={{
    __html:
      curinstrter.CourseInstructor_shortbio.length > 100
        ? `${curinstrter.CourseInstructor_shortbio.slice(0, 80)}...`
        : curinstrter.CourseInstructor_shortbio,
  }}
/>

       </div>
        </div>
      </div>
))}
    </div>
  </div>
</div>
<div className="overflow-hidden position-relative space bg-smoke" id="team-sec">
  <div className="shape-mockup instructor-bg-shape1 jump d-lg-block d-none" data-left="3%" data-bottom="30%">
    <img src="assets/img/normal/blog-3-bg-shape.png" alt="img" />
  </div>
  <div className="instructor_bg_shape2 shape-mockup d-xl-block d-none" data-left="-15%" data-top="3%">
    <img src="assets/img/normal/instructor_1_shape1.png" alt="img" />
  </div>
  <div className="container">
    <div className="row">
      <div className="col-xl-6 order-xl-2">
        <div className="become-instructor-img mb-5 mb-xl-0 ms-xl-5">
          <img src="assets/img/normal/become-instructor-thumb.png" alt="img" />
        </div>
      </div>
      <div className="col-xl-6 order-xl-1">
        <div className="title-area mb-30">
          <span className="sub-title"><i className="fal fa-book me-1" /> Instructor</span>
          <h2 className="sec-title">Become an Instructor On Our Online Platform.</h2>
        </div>
        <div className="row gy-4">
          <div className="col-sm-6">
            <div className="become-instructor-wrap">
              <i className="fa-solid fa-badge-check" />
              <h4 className="box-title">
                Teach your way
              </h4>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="become-instructor-wrap">
              <i className="fa-solid fa-badge-check" />
              <h4 className="box-title">
                Plan your curriculum
              </h4>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="become-instructor-wrap">
              <i className="fa-solid fa-badge-check" />
              <h4 className="box-title">
                Record your video
              </h4>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="become-instructor-wrap">
              <i className="fa-solid fa-badge-check" />
              <h4 className="box-title">
                Launch your course
              </h4>
            </div>
          </div>
        </div>

        {/* <NavLink to="/contact" className="th-btn mt-40">Get Instructor <i className="fa-regular fa-arrow-right ms-1" /></NavLink> */}

        < Wrapper>
        <div className="container">
        <NavLink to="" className="th-btn mt-5" onClick={openModal}>
          Get Instructor <i className="fa-regular fa-arrow-right ms-1" />
        </NavLink>
      </div>

      {/* Modal */}
      
      {isModalOpen && (

    <div className="modal" role="dialog" style={{ display: 'block' }}>
    <div className="modal-dialog" style={{ maxWidth: '500px', margin: 'auto' }}>
      <div className="modal-content" style={{ padding: '1px' }}>
        <div className="modal-body">
          {/* Form */}

          <form className="th-team-form bg-smoke ajax-contact mt-20" onSubmit={submitForm}>
            <div className="form-title mb-15 text-center">
              <h4 className="fw-semibold">Quick Contact</h4>
              <button type="button" className="close" onClick={closeModal} style={{ fontSize: '20px' }}>
                <span aria-hidden="true">&times;</span>
              </button>
              <p style={{ fontSize: '11px' }}>
                Feel free to contact us through Twitter or Facebook if you prefer!
              </p>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <input
                    type="text"
                    placeholder="Your Name"
                    name="name"
                    value={data.name}
                    required
                    onChange={handleInput}
                    className="form-control style-white"
                    style={{ padding: '8px', fontSize: '14px' }}
                  />
                  <i className="fal fa-user" />
                  
                  {errors.name && (
                  <span style={{ color:'red'}}>{errors.name}</span>
                   )}
                </div>
              </div>
              <div className="col-12">
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={data.email}
                    onChange={handleInput}
                    required
                    className="form-control style-white"
                    style={{ padding: '8px', fontSize: '14px' }}
                  />
                  <i className="fal fa-envelope" />
                  {errors.email && (
                  <span style={{ color: 'red'}}>{errors.email}</span>
                   )}
                </div>
              </div>
              <div className="col-12">
                <div className="form-group">
                  <input
                    type="number"
                    placeholder="Mobile Number"
                    name="mobile_number"
                    value={data.mobile_number}
                    onChange={handleInput}
                    required
                    className="form-control style-white"
                    style={{ padding: '8px', fontSize: '14px' }}
                  />
                  <i className="fal fa-phone-flip" />
                  {errors.mobile_number && (
                  <span style={{ color: 'red'}}>{errors.mobile_number}</span>
                   )}
                </div>
              </div>
              <div className="col-12">
                <div className="form-group">
                  <textarea
                    placeholder="Write Message..."
                    className="form-control style-white"
                    name="message"
                    value={data.message}
                    onChange={handleInput}
                    required
                    style={{ padding: '8px', fontSize: '14px' }}
                  />
                  <i className="fal fa-pencil" />
                  {errors.message && (
                  <span style={{ color: 'red'}}>{errors.message}</span>
                   )}
                </div>
              </div>
              <ReCAPTCHA
             sitekey="6LfZHGUrAAAAALvAACRghdiTSXqT6Fm25bjeEQ2L"
             onChange={onChange} style={{margin:"15px"}}
                />
              <div className="col-12 mt-2">
                <button
                  type="submit"
                  disabled={Enable} style={Enable?{opacity:'0.6' ,padding: '10px', fontSize: '14px'}:{opacity:'',padding: '10px', fontSize: '14px'}}
                  className="th-btn w-100"
                >
                  Send Message
                  <i className="fas fa-arrow-right ms-2" />
                </button>   
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  
  )}
          {formMessage && (
        <div className = "form-message">
          {formMessage}
        </div>
      )}
       </Wrapper>

      { single_instructer.map((curinstructer , index)=>(
       <Modal show={openinstructer} onHide={handleClose} size="xl" key={index}>
      <Modal.Header closeButton>
        <Modal.Title>{curinstructer.CourseInstructor_name}</Modal.Title>
      </Modal.Header>
      <Modal.Body className='bg-light'>
        <div className="container ">
          <div className="team-details-about-info bg-white">
            <div className="row gx-40" >
              <div className="col-lg-6 position-relative ">
                <div className="team-details-thumb">
                  <img src={`${BASE_URL}${curinstructer.CourseInstructor_image}`} alt="team image" />
                </div>
              </div>
              <div className="col-lg-6 ">
                <div className="about-box">
                  <div className="about-info">
                    <h3>{curinstructer.CourseInstructor_name}</h3>
                    <p className="desig">A certified instructor from Auratech Academy</p>
                  </div>
                  {/* <div className="th-social style2">
                    <a target="_blank" href={curinstructer.CourseInstructor_facebook_url}><i className="fab fa-facebook-f" /></a>
                    <a target="_blank" href={curinstructer.CourseInstructor_twitter_url}><i className="fab fa-twitter" /></a>
                    <a target="_blank" href={curinstructer.CourseInstructor_instgrame_url}><i className="fab fa-instagram" /></a>
                    <a target="_blank" href={curinstructer.CourseInstructor_linkedin_url}><i className="fab fa-linkedin-in" /></a>
                  </div> */}
                </div>
                {/* <p>{curinstructer.CourseInstructor_shortbio}</p> */}
               <p
  dangerouslySetInnerHTML={{
    __html: curinstructer.CourseInstructor_shortbio,
  }}
/>

                {/* <div className="about-quality">
                  <div className="quality-box">
                    <span className="quality-text">Course: 4</span>
                    <span className="quality-text">Students: 50</span>
                  </div>
                  <div className="quality-box">
                    <span className="quality-text">Reviews:</span>
                    <div className="course-rating">
                      <div className="star-rating" role="img" aria-label={`Rated ${curinstructer.CourseInstructor_rating} out of 5`}>
                        <span style={{ width: `${(curinstructer.CourseInstructor_rating / 5) * 100}%` }}>
                          Rated <strong className="rating">{curinstructer.CourseInstructor_rating}</strong> out of 5
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="quality-box">
                    <span className="quality-text">Experience:</span>
                    <span className="quality-text">{curinstructer.CourseInstructer_Exprince}</span>
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          <div className="space-top">
            <h3 className="title fw-semibold">Biography</h3>

            <p dangerouslySetInnerHTML={{ __html: curinstructer.Biography }}></p>
            
            <h3 className="title fw-semibold">Education qualification:</h3>

          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
        ))}

      </div>
    </div>
  </div>
</div>



    </>
  )
}
 const Wrapper = styled.section`
  .close {
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: #000;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
}

.close:hover {
  color: red;
}
.form-message {
  background-color:rgb(121, 200, 140);
  color:rgb(15, 82, 31);
  padding: 15px;
  margin-top: 20px;
  border: 2px solid #c3e6cb;
  border-radius: 5px;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.5s forwards;
  text-align : center;
  width : 50%
}
@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
 `


export default Our_Instructors
